import {createGlobalStyle} from "styled-components"

const GlobalStyles = createGlobalStyle`
    body {
        margin: 0;
    }
`

export default GlobalStyles
